<template>
    <div class="mt-2rem bundle-purchase-component bundle-purchase-layout-2 with-flexible-parts flex-wrap align-items-center">
        <div class="flexible-part">
            <p class="learnworlds-main-text-large">
                <span class='lw-deleted-price lw-text-color-fadeout50'>{{ bundle.currency }}{{ bundle.price }} </span>
                <strong>{{ bundle.currency }}{{ bundle.discount_price }}</strong>
            </p>
        </div>
        <div class="flexible-part">
            <button class="learnworlds-button learnworlds-element learnworlds-button-large learnworlds-button-solid-accent1" @click="enrollButtonClicked">
                {{ $t('bundles.buy') }}
            </button>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "BundlePurchaseLayout2",
        mixins: [ComponentTemplatesMixin],
        props: {
            bundle : {
                type: Object
            }
        },
        methods: {
            enrollButtonClicked () {
                this.emitAction('bundle-clicked', this.bundle)
            },
        }
    }
</script>

